export const mbtiResults = {
  "INTJ": {
    title: "전략가 (Architect)",
    description: "상상력이 풍부하고 전략적인 사고를 가진 혁신가입니다. 모든 가능성을 고려하는 계획을 세우는 데 뛰어납니다.",
    strengths: ["분석적", "독립적", "전략적", "창의적"],
    weaknesses: ["냉소적일 수 있음", "지나치게 비판적", "사회적 상황에서 어색할 수 있음"],
    compatibility: ["ENFP", "ENTP"],
    careers: ["과학자", "엔지니어", "분석가", "전략 컨설턴트", "법률가"]
  },
  "INTP": {
    title: "논리학자 (Logician)",
    description: "호기심이 많고 발명을 좋아하는 철학자입니다. 끊임없이 새로운 지식을 추구합니다.",
    strengths: ["논리적", "독창적", "개방적", "객관적"],
    weaknesses: ["지나치게 분석적", "우유부단할 수 있음", "실용성 부족"],
    compatibility: ["ENTJ", "ESTJ"],
    careers: ["프로그래머", "물리학자", "철학자", "수학자", "연구원"]
  },
  "ENTJ": {
    title: "통솔자 (Commander)",
    description: "대담하고 상상력이 풍부한 강한 의지의 지도자입니다. 항상 길을 찾아내는 사람입니다.",
    strengths: ["효율적", "결단력 있음", "카리스마", "자신감"],
    weaknesses: ["완고함", "참을성 부족", "감정 표현에 서툴 수 있음"],
    compatibility: ["INTP", "ISTP"],
    careers: ["경영자", "기업가", "정치가", "변호사", "컨설턴트"]
  },
  "ENTP": {
    title: "변론가 (Debater)",
    description: "지적 도전을 즐기는 영리하고 호기심 많은 사고가입니다. 늘 새로운 것을 추구합니다.",
    strengths: ["혁신적", "지적", "적응력", "유연함"],
    weaknesses: ["논쟁적", "미루는 경향", "집중력 부족"],
    compatibility: ["INTJ", "INFJ"],
    careers: ["기업가", "변호사", "컨설턴트", "엔지니어", "과학자"]
  },
  "INFJ": {
    title: "옹호자 (Advocate)",
    description: "조용하고 신비로우며 영감을 주는 이상주의자입니다. 다른 이들의 성장을 돕는 것을 좋아합니다.",
    strengths: ["이상주의적", "통찰력", "원칙적", "창의적"],
    weaknesses: ["완벽주의", "번아웃 위험", "현실과 동떨어질 수 있음"],
    compatibility: ["ENTP", "ENFP"],
    careers: ["상담사", "심리학자", "작가", "교사", "예술가"]
  },
  "INFP": {
    title: "중재자 (Mediator)",
    description: "시적이고 친절하며 이타적인 성격으로, 항상 좋은 일을 찾아 돕고 싶어합니다.",
    strengths: ["이상주의적", "창의적", "개방적", "공감 능력"],
    weaknesses: ["비현실적", "지나치게 감정적일 수 있음", "우유부단함"],
    compatibility: ["ENFJ", "ENTJ"],
    careers: ["작가", "심리학자", "교사", "예술가", "디자이너"]
  },
  "ENFJ": {
    title: "선도자 (Protagonist)",
    description: "카리스마 있고 영감을 주는 지도자로, 청중을 매료시키고 사람들을 이끕니다.",
    strengths: ["카리스마", "이타적", "신뢰할 수 있음", "영감을 줌"],
    weaknesses: ["과도하게 이상주의적", "지나치게 민감할 수 있음", "사생활 필요"],
    compatibility: ["INFP", "ISFP"],
    careers: ["교사", "상담사", "인사 관리자", "마케터", "정치가"]
  },
  "ENFP": {
    title: "활동가 (Campaigner)",
    description: "열정적이고 창의적인 자유로운 영혼으로, 항상 새로운 가능성을 찾아 나섭니다.",
    strengths: ["열정적", "창의적", "사교적", "에너지 넘침"],
    weaknesses: ["산만함", "실용적이지 않을 수 있음", "스트레스에 취약"],
    compatibility: ["INTJ", "INFJ"],
    careers: ["저널리스트", "배우", "마케터", "상담사", "이벤트 기획자"]
  },
  "ISTJ": {
    title: "현실주의자 (Logistician)",
    description: "실용적이고 사실 중심적인 사람들로, 신뢰성과 책임감이 강합니다.",
    strengths: ["책임감", "조직적", "정직함", "실용적"],
    weaknesses: ["융통성 부족", "새로운 방식에 저항", "지나치게 엄격함"],
    compatibility: ["ESFP", "ESTP"],
    careers: ["관리자", "회계사", "군인", "법률가", "경영자"]
  },
  "ISFJ": {
    title: "수호자 (Defender)",
    description: "매우 헌신적이고 따뜻한 수호자로, 항상 사랑하는 사람들을 보호할 준비가 되어 있습니다.",
    strengths: ["헌신적", "참을성", "신뢰성", "세심함"],
    weaknesses: ["변화에 저항", "자기주장 부족", "과도한 희생"],
    compatibility: ["ESFP", "ESTP"],
    careers: ["간호사", "초등학교 교사", "행정 보조", "소셜 워커", "인사 관리자"]
  },
  "ESTJ": {
    title: "경영자 (Executive)",
    description: "훌륭한 관리자로, 사물과 사람을 관리하는 데 탁월합니다.",
    strengths: ["구조적", "리더십", "신뢰성", "결단력"],
    weaknesses: ["융통성 부족", "지나치게 독단적", "감정 표현에 서툴 수 있음"],
    compatibility: ["INTP", "ISFP"],
    careers: ["관리자", "군인", "경영자", "판사", "금융 분석가"]
  },
  "ESFJ": {
    title: "집정관 (Consul)",
    description: "배려심이 많고 사교적이며 인기 있는 사람들로, 항상 다른 사람을 돕고자 합니다.",
    strengths: ["친절함", "사교성", "신뢰성", "실용적"],
    weaknesses: ["갈등 회피", "비판에 민감", "인정 욕구"],
    compatibility: ["ISTP", "ISFP"],
    careers: ["교사", "의료 종사자", "사회 복지사", "판매 관리자", "이벤트 기획자"]
  },
  "ISTP": {
    title: "장인 (Virtuoso)",
    description: "대담하고 실용적인 실험가로, 다양한 도구를 자유자재로 다루는 기술자입니다.",
    strengths: ["적응력", "문제 해결능력", "실용적", "창의적 기술자"],
    weaknesses: ["충동적", "약속에 소홀할 수 있음", "감정 표현에 서툴 수 있음"],
    compatibility: ["ESTJ", "ESFJ"],
    careers: ["기계공", "엔지니어", "파일럿", "경찰", "운동선수"]
  },
  "ISFP": {
    title: "모험가 (Adventurer)",
    description: "유연하고 매력적인 예술가로, 항상 새로운 경험과 감각을 찾아 나섭니다.",
    strengths: ["창의성", "민감성", "충성심", "적응력"],
    weaknesses: ["쉽게 스트레스받음", "갈등 회피", "장기 계획 어려움"],
    compatibility: ["ENFJ", "ESTJ"],
    careers: ["예술가", "디자이너", "음악가", "요리사", "치료사"]
  },
  "ESTP": {
    title: "사업가 (Entrepreneur)",
    description: "스마트하고 에너지 넘치며 매우 인식력이 뛰어난 사람들로, 위험을 감수하는 것을 즐깁니다.",
    strengths: ["에너지 넘침", "실용성", "적응력", "문제 해결 능력"],
    weaknesses: ["인내심 부족", "위험 감수", "약속에 소홀할 수 있음"],
    compatibility: ["ISTJ", "ISFJ"],
    careers: ["기업가", "마케터", "영업 담당자", "스포츠 코치", "경찰"]
  },
  "ESFP": {
    title: "연예인 (Entertainer)",
    description: "자발적이고 활기차며 열정적인 연예인으로, 주변을 밝게 만드는 사람입니다.",
    strengths: ["대인관계", "열정", "재미있음", "관찰력"],
    weaknesses: ["장기 계획 어려움", "집중력 부족", "너무 감정적일 수 있음"],
    compatibility: ["ISTJ", "ISFJ"],
    careers: ["배우", "이벤트 기획자", "판매 담당자", "여행 가이드", "요식업 종사자"]
  }
};